import FilterItem from '../FilterItem';

class FilterSingle extends FilterItem {
  constructor(conf, subcategory) {
    super(conf, subcategory);
  }

  async apply(values) {
    if (Array.isArray(values) && values.length === 1) {
      this.value = values[0];
      return;
    }
    this.value = values;
  }

  collectValues() {
    let value = {};
    if (this.isNA) {
      value = this.naFilter;
    } else {
      value[this.property] = this.parseQueryString(this.value);
    }
    return value;
  }

  resetValue = () => {
    this.value = null;
  };

  parseQueryString(inputString) {
    if (this.splittable) {
      const pattern = this.splitPattern;
      if (!pattern.test(inputString)) {
        return inputString;
      }
      const resultArray = Array.isArray(inputString) ? inputString.join().split(pattern) : inputString.split(pattern);
      return resultArray.filter((str) => str.trim() !== '');
    } else {
      return Array.isArray(inputString) ? inputString[0] : inputString;
    }
  }
}

export default FilterSingle;
